import { Component, OnInit, Input } from '@angular/core';
import { RmsModule } from '@rms';
import { WebService, PromptService, RmsMessageService, lastValueFrom } from '@services';
import { Column } from '@interfaces';

@Component({
  selector: 'app-traffic-notes',
  imports: [RmsModule],
  templateUrl: './traffic-notes.component.html',
  styleUrl: './traffic-notes.component.scss'
})
export class TrafficNotesComponent implements OnInit {
  @Input() InventoryID: number | null = null;
  @Input() PurchaseOrderID: number | null = null;
  @Input() MultipleInventoryItems: boolean = false;
  DataLoaded: boolean = false;
  TrafficNotes: any[] = [];
  TrafficNotesColumns: Column[] = []
  constructor(private webService: WebService, private prompt: PromptService, private message: RmsMessageService) { }

  async ngOnInit() {
    console.log('Traffic Notes InventoryID:', this.InventoryID);
    await this.GetTrafficNotes();
    this.DataLoaded = true;
  }

  async GetTrafficNotes() {
    this.TrafficNotes = await lastValueFrom(this.webService.getWebCall('inventory', '/coffee/traffic-notes', { params: [{value: this.InventoryID, name: 'InventoryID'}]}));
    this.TrafficNotesColumns = [
      { label: 'Date', key: 'DateEntered', type: 'date', width:10 },
      { label: 'Traffic Note', key: 'TrafficNote', width:60 },
      { label: 'Entered By', key: 'EnteredBy', width: 30 }
    ]
  }
  onClickNewNote() {
    let buttons = this.MultipleInventoryItems ?
      ([{ label: "Ref#: " + this.InventoryID, value: false, buttonClass: 'btn-bg-blue' },
      { label: "PO#: " + this.PurchaseOrderID, value: true, buttonClass: 'btn-bg-blue' },]) :
      ([{ label: "Save", value: false, buttonClass: 'btn-bg-blue' },])
    let promptText = this.MultipleInventoryItems ? "Please add traffic note and select to update Reff: " + this.InventoryID + " or Purchase Order: " + this.PurchaseOrderID + "." :
      "Please add traffic note to update Reff: " + this.InventoryID + "."
    const { closed$ } = this.prompt.open({
      promptText: promptText,
      buttons: buttons,
      promptInput: 'textarea',
      inputRequired: true,
      inputLabel: 'Traffic Note (Required)'
    })
    closed$.subscribe(async (result) => {
      if (result !== null) {
        this.UpdateTrafficNote(result.buttonValue, result.inputValue);
      }
      else {
        await this.ngOnInit();
      }
    })
  }
  async UpdateTrafficNote(EntirePO: boolean, TrafficNote: string) {
    const Notesbody = {
      InventoryID: this.InventoryID,
      PurchaseOrderID: this.PurchaseOrderID,
      TrafficNote: TrafficNote,
      EnteredBy: localStorage.getItem('displayName'),
      UpdatePurchaseOrder: EntirePO
    }
    try {
      await lastValueFrom(this.webService.getWebCall('inventory', '/coffee/traffic-notes/update', { body: Notesbody }));
      this.message.success("Successfully Updated Date and Added Traffic Note")
      await this.GetTrafficNotes()
    }
    catch (err) {
      this.message.error("Error Updating Date or Adding Traffic Note: " + err);
    }

  }

}
